import React from 'react';
import { useTable, useSortBy } from 'react-table';

function useInstance(instance) {
  const { allColumns } = instance;

  let rowSpanHeaders = [];

  allColumns.forEach((column, i) => {
    const { id, enableRowSpan } = column;

    if (enableRowSpan !== undefined) {
      rowSpanHeaders = [...rowSpanHeaders, { id, topCellValue: null, topCellIndex: 0 }];
    }
  });

  Object.assign(instance, { rowSpanHeaders });
}

const TableComponent = ({ data, columns, onClick }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows: tableRows,
    prepareRow,
    rowSpanHeaders,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        sortBy: [
          {
            id: columns[columns.length - 1]?.accessor,
            desc: true,
          },
        ],
      },
    },
    useSortBy,
    (hooks) => {
      hooks.useInstance.push(useInstance);
    }
  );

  return (
    <table className='data-table table table-bordered' {...getTableProps()}>
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => (
              <th
                {...column.getHeaderProps(column.getSortByToggleProps())}
                className={`${
                  column.id === columns[0].accessor ? 'left-header' : 'center-header'
                } ${column.hidden ? 'th-hidden' : ''}`}
              >
                {column.render('Header')}
                <span className='sort-indicator-asc'>
                  {column.isSorted ? (
                    column.isSortedDesc ? (
                      ' 🔽'
                    ) : (
                      ' 🔼'
                    )
                  ) : column.canSort ? (
                    <span className='sort-indicator'>↕</span>
                  ) : (
                    ''
                  )}
                </span>
              </th>
            ))}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {tableRows.map((row, i) => {
          prepareRow(row);

          for (let j = 0; j < row.allCells.length; j++) {
            let cell = row.allCells[j];
            let rowSpanHeader = rowSpanHeaders.find((x) => x.id === cell.column.id);

            if (rowSpanHeader !== undefined) {
              if (
                rowSpanHeader.topCellValue === null ||
                rowSpanHeader.topCellValue !== cell.value
              ) {
                cell.isRowSpanned = false;
                rowSpanHeader.topCellValue = cell.value;
                rowSpanHeader.topCellIndex = i;
                cell.rowSpan = 1;
              } else {
                tableRows[rowSpanHeader.topCellIndex].allCells[j].rowSpan++;
                cell.isRowSpanned = true;
              }
            }
          }
          return null;
        })}
        {tableRows.map((row) => {
          return (
            <tr {...row.getRowProps()}>
              {row.cells.map((cell) => {
                if (cell.isRowSpanned) return null;
                else
                  return (
                    <td
                      rowSpan={cell.rowSpan}
                      {...cell.getCellProps()}
                      onClick={() => cell.column.clickable && onClick && onClick(cell)}
                      className={`${cell.column.clickable ? 'link-style' : ''} ${
                        cell.column.hidden ? 'td-hidden' : ''
                      }`}
                    >
                      {cell.render('Cell')}
                    </td>
                  );
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default TableComponent;
